import { styled } from "styled-components";
import { Assets } from "../styles/assets";
import { AiOutlineClose } from "react-icons/ai";

type Position = "bottom-right" | "bottom-left" | "top-right" | "top-left";

export const BtnPrimaryStyle = styled.button<{
    $width?: string,
    $height?: string,
    $margintop?: string,
    $marginbottom?: string,
    disabled?: boolean
}>`
  width: ${({ $width }) => $width || "100%"};
  height: ${({ $height }) => $height || "52px"};  
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  color: #000;  
  border-radius: 8px;  
  background: ${({ disabled }) => disabled ? "#2A2A2A" : Assets.primaryColor};
  cursor: pointer;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  margin-top: ${({ $margintop }) => $margintop || "40px"};
  margin-bottom: ${({ $marginbottom }) => $marginbottom || "40px"};
  &:hover {
    background: ${Assets.primaryColorHover};
    color: #000;
  } 
`;

export const BtnPrimaryOutStyle = styled.button<{
  $width?: string,
  $height?: string,
  $margintop?: string,
  $marginbottom?: string,
  disabled?: boolean
}>`
width: ${({ $width }) => $width || "100%"};
height: ${({ $height }) => $height || "52px"};  
text-decoration: none;
display: flex;
justify-content: center;
align-items: center;
border: none;
color: ${Assets.primaryColor};  
border-radius: 12px;  
background: transparent;
border: 2px solid ${Assets.primaryColor};
cursor: pointer;
font-family: 'Inter', Arial, sans-serif;
font-size: 16px;
font-weight: bold;
margin-top: ${({ $margintop }) => $margintop || "40px"};
margin-bottom: ${({ $marginbottom }) => $marginbottom || "40px"};
&:hover {
  background: ${Assets.primaryColor};
  color: #000;
} 
`;

export const BtnDarnStyle = styled.button<{
  width?: string,
  height?: string,
  margintop?: string,
  marginbottom?: string,
  disabled?: boolean
}>`
width: ${({ width }) => width || "100%"};
height: ${({ height }) => height || "52px"};  
text-decoration: none;
display: flex;
justify-content: center;
align-items: center;
border: 1px solid  #ffffff1a;
color:rgb(205, 205, 205);  
border-radius: 8px;  
background: transparent;
cursor: pointer;
font-family: 'Inter', Arial, sans-serif;
font-size: 16px;

margin-top: ${({ margintop }) => margintop || "40px"};
margin-bottom: ${({ marginbottom }) => marginbottom || "40px"};
&:hover {
  color: #fff;
}
`;

export const BtnRedStyle = styled.button<{
    width?: string,
    margintop?: string,
    marginbottom?: string,
    disabled?: boolean
}>`
  width: ${({ width }) => width || "200px"};
  height: 60px;  
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  color: #fff;  
  border-radius: 5px;  
  background: ${Assets.redColor};
  cursor: pointer;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  margin-top: ${({ margintop }) => margintop || "40px"};
  margin-bottom: ${({ marginbottom }) => marginbottom || "40px"};
  &:hover {
    background: ${Assets.redColorHover};
    color: #fff;
  } 
`;

export const BtnRedOutlineStyle = styled.button<{
    width?: string,
    height?: string,
    margintop?: string,
    marginbottom?: string,
    disabled?: boolean
}>`
  width: ${({ width }) => width || "200px"};
  height: ${({ height }) => height || "60px"};  
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  color: ${Assets.redColor};  
  border-radius: 5px;  
  background: transparent;
  border: 3px solid ${Assets.redColor};
  cursor: pointer;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  margin-top: ${({ margintop }) => margintop || "40px"};
  margin-bottom: ${({ marginbottom }) => marginbottom || "40px"};
  &:hover {
    background: ${Assets.redColorHover};
    color: #fff;
    border:0px;
  } 
`;

export const FabButtonContainer = styled.button<{ $position: Position; $size: number }>`
    position: fixed;
    ${({ $position }) => getPositionStyles($position)}
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    border-radius: 50%;
    background: ${Assets.primaryColor};
    color: #000;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${({ $size }) => $size * 0.5}px;
    font-weight: bold;
    font-family: 'Inter', Arial, sans-serif;
    box-shadow: 0 4px 12px rgba(4, 249, 204, 0.4);
    z-index: 1000;
    transition: all 0.3s ease;
    
    &:hover {
        transform: scale(1.1);
        box-shadow: 0 6px 16px rgba(4, 249, 204, 0.6);
    }
    
    &:active {
        transform: scale(0.95);
    }
    
    span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }
`;

export const Loading = styled.img`
  width: 30px;
  height: 30px;
  margin-left: 10px;
`;

const getPositionStyles = (position: Position) => {
    switch (position) {
        case "bottom-right":
            return `
                bottom: 24px;
                right: 24px;
            `;
        case "bottom-left":
            return `
                bottom: 24px;
                left: 24px;
            `;
        case "top-right":
            return `
                top: 24px;
                right: 24px;
            `;
        case "top-left":
            return `
                top: 24px;
                left: 24px;
            `;
        default:
            return `
                bottom: 24px;
                right: 24px;
            `;
    }
};

export const CircleBtnStyle = styled.button<{ $color: string; $selected?: boolean }>`
  width: 85px;      
  height: 85px;
  border: none;
  background: ${({ $color }) => $color}; 
  border: 3px solid ${({ $selected, $color }) => {
    if ($selected) return '#ffffff';
    const isLight = $color === '#ffffff' || $color.toLowerCase() === '#fff';
    return isLight ? 'rgba(0,0,0,0.15)' : 'transparent';
  }};     
  cursor: pointer;
  flex-shrink: 0;  
  &:hover { 
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }  
  margin:10px;
  border-radius: 10px;
`;

export const BtnOpacityStyle = styled.button<{
  width?: string,
  margintop?: string,
  marginbottom?: string,
  disabled?: boolean
}>`
width: ${({ width }) => width || "200px"};
height: 52px;  
text-decoration: none;
display: flex;
justify-content: center;
align-items: center;
color: #04F9CC; 
border-radius: 12px;  
cursor: pointer;
font-family: 'Inter', Arial, sans-serif;
font-size: 16px;
font-weight: 700;
margin-top: ${({ margintop }) => margintop || "40px"};
margin-bottom: ${({ marginbottom }) => marginbottom || "40px"};
transition: all .18s;
background: rgba(4, 249, 204, 0.08);
border: 1.5px solid rgba(4, 249, 204, 0.3);
&:hover {
  color: #04F9CC;   
  background: rgba(4, 249, 204, 0.15);
} 
`;

export const ButtonCloseStyle = styled(AiOutlineClose)`
    width: 32px; height: 32px;
    background: #1A1A1A;
    border: 1px solid #2A2A2A;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    color: #666;
    transition: all .15s;
    flex-shrink: 0;
    padding: 5px;
    margin-right: 10px;
    box-sizing: border-box;
  &:hover {
    background: #2A2A2A; 
    color: #fff;
  }
`;
